import type React from 'react';
import { type DocumentTitleSubscriber, DocumentTitleHelper } from './DocumentTitleContainer.tsx';

type DocumentTitleProps = {
	title: string;
	TitleSubscriber?: typeof DocumentTitleSubscriber; // remove on jira-concurrent-document-title cleanup
};

export const DocumentTitle: (props: DocumentTitleProps) => React.ReactNode = DocumentTitleHelper;
